
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/[propertyid]",
      function () {
        return require("private-next-pages/properties/[propertyid]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/[propertyid]"])
      });
    }
  